import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i7 from '@angular/forms';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil, take } from 'rxjs/operators';
import * as i3 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails, getDataSourceCountryList, SetDataSourceCountryList } from 'visa-store';
import * as i1 from 'cache-country-list';
import * as i2 from 'reference-library';
import * as i4 from 'custom-dropdown';
import * as i5 from '@angular/router';
import * as i6 from 'app-services-library';
import * as i8 from '@angular/common';
import { CommonModule } from '@angular/common';

class VdCountryStateService {
    constructor() { }
}
VdCountryStateService.ɵfac = function VdCountryStateService_Factory(t) { return new (t || VdCountryStateService)(); };
VdCountryStateService.ɵprov = i0.ɵɵdefineInjectable({ token: VdCountryStateService, factory: VdCountryStateService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdCountryStateService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function VdCountryStateComponent_em_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 14);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function VdCountryStateComponent_option_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r4.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r4.name);
} }
function VdCountryStateComponent_option_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r5.stateProvinceCode);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("", item_r5.stateProvinceName, " ");
} }
function VdCountryStateComponent_em_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 14);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
class VdCountryStateComponent {
    constructor(apiService, referenceLibraryService, store, customDropdownService, route, appServicesLibraryService) {
        this.apiService = apiService;
        this.referenceLibraryService = referenceLibraryService;
        this.store = store;
        this.customDropdownService = customDropdownService;
        this.route = route;
        this.appServicesLibraryService = appServicesLibraryService;
        this.disabledControls = false;
        this.group = new FormGroup({});
        this.listStates = [];
        this.observableSubscription$ = new Subject();
    }
    ngOnInit() {
        this.getCountry();
        this.initForm();
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    initForm() {
        let fmg = Object.assign(this.groupName);
        let country = this.inputParams.value && this.inputParams.value.country ? this.inputParams.value.country : '';
        let state = this.inputParams.value && this.inputParams.value.state ? this.inputParams.value.state : '';
        let stateProvinceCode = this.inputParams.value && this.inputParams.value.stateProvinceCode ? this.inputParams.value.stateProvinceCode : '';
        if (country) {
            this.handleCountryChange(country, true);
        }
        this.group.addControl(fmg, new FormGroup({
            country: new FormControl(country),
            state: new FormControl(state),
            stateProvinceCode: new FormControl(stateProvinceCode),
        }));
        this.route.queryParams.subscribe(params => {
            const stepParameter = params['step'];
            if (stepParameter) {
                this.listStates = this.customDropdownService.getRefDataSource(this.inputParams.name);
            }
        });
        if (this.inputData) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                this.toggleFields();
            });
        }
    }
    getCountry() {
        this.store.pipe(select(getDataSourceCountryList))
            .pipe(take(1))
            .subscribe((data) => {
            if (data && data.length > 0) {
                this.referenceLibraryService.translateArray(data, 'name')
                    .then(translated => {
                    this.countryList = translated;
                })
                    .catch(error => console.error("Translation error:", error));
            }
            else {
                this.referenceLibraryService.getDataSource('COUNTRY', '')
                    .pipe(take(1))
                    .subscribe((response) => {
                    this.referenceLibraryService.translateArray(response || [], 'name')
                        .then(translated => {
                        this.countryList = translated;
                    })
                        .catch(error => console.error("Translation error:", error));
                    this.store.dispatch(new SetDataSourceCountryList(response || null));
                });
            }
        });
    }
    handleCountryChange(evt, fromValue) {
        let fmg = Object.assign(this.groupName);
        let countryCode = fromValue ? evt : evt.target.value;
        if (countryCode) {
            this.referenceLibraryService.getStatesFromStore(countryCode)
                .pipe(take(1))
                .subscribe((states) => {
                if (states) {
                    this.referenceLibraryService.translateArray(states, 'stateProvinceName')
                        .then(translated => {
                        this.listStates = translated;
                    })
                        .catch(error => console.error("Translation error:", error));
                }
                else {
                    this.referenceLibraryService.getStatesFromApi(countryCode)
                        .pipe(take(1))
                        .subscribe((data) => {
                        this.referenceLibraryService.translateArray(data || [], 'stateProvinceName')
                            .then(translated => {
                            this.listStates = translated;
                            this.customDropdownService.setRefDataSource(this.inputParams.name, this.listStates);
                        })
                            .catch(error => console.error("Translation error:", error));
                    });
                }
            });
        }
        else {
            this.group.controls[fmg].patchValue({
                stateProvinceCode: ''
            });
        }
    }
    toggleFields() {
        this.userType = sessionStorage.getItem('userTypeRole');
        if (((this.userType == 'Petitioner' || this.userType == 'Attorney') && this.inputData.stepStatusCode == 'COMPLETE') || (this.userType == 'Beneficiary' && (this.inputData.stepStatusCode === 'COMPLETE' || this.inputData.stepStatusCode == 'SUBMIT'))) {
            // this.childGroup.disable();
            this.group.disable();
        }
        else {
            //  this.childGroup.enable();
            this.group.enable();
        }
    }
    OnStateSelect(evt) {
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
VdCountryStateComponent.ɵfac = function VdCountryStateComponent_Factory(t) { return new (t || VdCountryStateComponent)(i0.ɵɵdirectiveInject(i1.CacheCountryListService), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(i4.CustomDropdownService), i0.ɵɵdirectiveInject(i5.ActivatedRoute), i0.ɵɵdirectiveInject(i6.AppServicesLibraryService)); };
VdCountryStateComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdCountryStateComponent, selectors: [["vd-country-state"]], inputs: { address: "address", groupName: "groupName", inputParams: "inputParams", inputData: "inputData", group: "group" }, decls: 24, vars: 11, consts: [[1, "w-100", 2, "font-size", "14px", 3, "formGroup"], [1, "w-100", 3, "formGroupName"], [1, "row"], [1, "col", "mb-2"], [1, "label-cls", "common-bene-class-for-translation", 2, "padding-bottom", "5px"], ["class", "error", 4, "ngIf"], ["formControlName", "country", 1, "form-control", 3, "ngStyle", "change"], ["value", "", 1, "common-bene-class-for-translation"], [3, "value", 4, "ngFor", "ngForOf"], [1, "col", "mb-2", 3, "hidden"], ["formControlName", "stateProvinceCode", 1, "form-control", 3, "ngStyle", "change"], [1, "label-cls"], [1, "common-bene-class-for-translation"], ["type", "text", "formControlName", "state", "placeholder", "State", 1, "im-input", "col-md", 3, "ngStyle"], [1, "error"], [3, "value"]], template: function VdCountryStateComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "label", 4);
        i0.ɵɵtext(5, "Country");
        i0.ɵɵtemplate(6, VdCountryStateComponent_em_6_Template, 2, 0, "em", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "select", 6);
        i0.ɵɵlistener("change", function VdCountryStateComponent_Template_select_change_7_listener($event) { return ctx.handleCountryChange($event); });
        i0.ɵɵelementStart(8, "option", 7);
        i0.ɵɵtext(9, "Select");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(10, VdCountryStateComponent_option_10_Template, 2, 2, "option", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 9);
        i0.ɵɵelementStart(12, "label", 4);
        i0.ɵɵtext(13, "State");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "select", 10);
        i0.ɵɵlistener("change", function VdCountryStateComponent_Template_select_change_14_listener($event) { return ctx.OnStateSelect($event); });
        i0.ɵɵelementStart(15, "option", 7);
        i0.ɵɵtext(16, "Select");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, VdCountryStateComponent_option_17_Template, 2, 2, "option", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(18, "div", 9);
        i0.ɵɵelementStart(19, "label", 11);
        i0.ɵɵelementStart(20, "span", 12);
        i0.ɵɵtext(21, "State");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(22, VdCountryStateComponent_em_22_Template, 2, 0, "em", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(23, "input", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroupName", ctx.groupName);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", ctx.inputParams.groupElementProperty.countryStyle);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.countryList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", !((ctx.listStates == null ? null : ctx.listStates.length) > 0));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngStyle", ctx.inputParams.groupElementProperty.stateStyle);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.listStates);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("hidden", !((ctx.listStates == null ? null : ctx.listStates.length) == 0));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngStyle", ctx.inputParams.groupElementProperty.stateStyle);
    } }, directives: [i7.NgControlStatusGroup, i7.FormGroupDirective, i7.FormGroupName, i8.NgIf, i7.SelectControlValueAccessor, i7.NgControlStatus, i7.FormControlName, i8.NgStyle, i7.NgSelectOption, i7.ɵangular_packages_forms_forms_z, i8.NgForOf, i7.DefaultValueAccessor], styles: [".error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}.label-cls[_ngcontent-%COMP%]{font-size:14px!important}.form-control[_ngcontent-%COMP%]{height:40px}.row[_ngcontent-%COMP%]{margin-right:-15px;margin-left:-15px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdCountryStateComponent, [{
        type: Component,
        args: [{
                selector: 'vd-country-state',
                templateUrl: 'vd-country-state.component.html',
                styleUrls: ['vd-country-state.component.scss']
            }]
    }], function () { return [{ type: i1.CacheCountryListService }, { type: i2.ReferenceLibraryService }, { type: i3.Store }, { type: i4.CustomDropdownService }, { type: i5.ActivatedRoute }, { type: i6.AppServicesLibraryService }]; }, { address: [{
            type: Input
        }], groupName: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], inputData: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class VdCountryStateModule {
}
VdCountryStateModule.ɵfac = function VdCountryStateModule_Factory(t) { return new (t || VdCountryStateModule)(); };
VdCountryStateModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdCountryStateModule });
VdCountryStateModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdCountryStateModule, { declarations: [VdCountryStateComponent], imports: [CommonModule,
        ReactiveFormsModule], exports: [VdCountryStateComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdCountryStateModule, [{
        type: NgModule,
        args: [{
                declarations: [VdCountryStateComponent],
                imports: [
                    CommonModule,
                    ReactiveFormsModule
                ],
                exports: [VdCountryStateComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-country-state
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdCountryStateComponent, VdCountryStateModule, VdCountryStateService };
//# sourceMappingURL=vd-country-state.js.map
